import { CareShell, CareShellActiveContext } from "components/care/CareLayout";
import { Outlet } from "react-router-dom";


export default function CareLayoutRoute() {
  return (
    <CareShell>
      <CareShellActiveContext.Provider value={true}>
        <Outlet />
      </CareShellActiveContext.Provider>
    </CareShell>
  );
}